var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"text-list text-justify"},[_vm._l((_vm.items),function(item,index){return [_c('span',{key:'item' + index,staticClass:"text-list__item",domProps:{"innerHTML":_vm._s(item)}}),_vm._v(".\n    ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }